import React from 'react'
import './template.css'
import { Link } from "react-router-dom";

const LeftAlignTwoColumn = ({ data }) => {
  return (
    <div className={("LeftAlignTwoColumn " + data.class)}>
      {data.title && data.title.text && <h1 className={data.title.class || ""}>{data.title.text}</h1>}
      {data.columns && data.columns.length > 0 && data.columns.map((column, idx) => {
        return <LeftAlignColumn key={column.title + idx} column={column} />
      })}
    </div>
  )
}

const LeftAlignColumn = ({ column }) => {
  return (
    <div className={"LeftAlignColumn"}>
      <div className={"sm-right align-left"}>
        {column.title && column.title.text && <h1 className={column.title.class || ""}>{column.title.text}</h1>}
      </div>
      <div className={"right "}>
        {column.paragraph && column.paragraph.text && <p className={column.paragraph.class || ""}>{column.paragraph.text}</p>}
        {column.link? column.link.external? <a target="_blank" rel="noopener noreferrer" className={column.link.class} href={column.link.url}> {column.link.text} </a> : <Link className={column.link.class} to={column.link.url}> {column.link.text}</Link>: null}
      </div>
    </div>
  )
}

export default LeftAlignTwoColumn